export default __webpack_public_path__ + "static/suzie-dd2168e0e5c4b9702029862ee88a47b3.png";